module.exports = __webpack_public_path__ + "img/logo.72cba38b.svg";